module.exports = __webpack_public_path__ + "img/file_bundle.da496874.png";